import { E_RouterNames } from "@/router/types";

export interface IBuildTempVibAlarmHistoryRouterParams {
    companyId: number
    areaId: number
    equipmentId: number
    mappingId?: number
    sensorId?: string
    createTime?: string
}

export function buildTempVibAlarmHistoryRouter(params: IBuildTempVibAlarmHistoryRouterParams) {
    return {
        name: E_RouterNames.TempVibAlarmHistory,
        query: params
    }
}
